<template>
<tr>
     <td>
            <select :name="'serviceLists[lines][' + index + '][type]'" v-model="serviceList.type" class="form-control form-control-sm" :required="serviceList.designation != '' && serviceList.designation != null">
                <option value="">Choisir une catégorie</option>
                <option v-for="(type, value) in types" :value="type.value" :key="value">{{ type.label }}</option>
            </select>

            <select :name="'serviceLists[lines][' + index + '][type_secondary]'" v-model="serviceList.type_secondary" class="form-control form-control-sm mt-2" required v-if="serviceList.type == 2">
                <option value="">Choisir une sous-catégorie</option>
                <option v-for="(type, value) in purchaseTypes" :value="type.value" :key="value">{{ type.label }}</option>
            </select>
        </td>
         <td>
            <input type="text" class="form-control form-control-sm" :name="'serviceLists[lines][' + index + '][reference]'" v-model="serviceList.reference">
        </td>
         <td>
            <div class="input-group">
                <div class="input-group-prepend" v-if="serviceList.article_id">
                    <span class="input-group-text"><i class="far fa-cube"></i></span>
                </div>  

                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + serviceList.uniq" type="text" :name="'serviceLists[lines][' + index + '][designation]'" v-model="serviceList.designation" :required="serviceList.type != ''">
            </div>
            <input type="hidden" :name="'serviceLists[lines][' + index + '][id]'" v-model="serviceList.id">
            <input type="hidden" :name="'serviceLists[lines][' + index + '][article_id]'" v-model="serviceList.article_id">
            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" placeholder="description, informations complémentaires, .." :name="'serviceLists[lines][' + index + '][description]'" v-model="serviceList.description"></textarea>
            </div>
        </td>
        <td>
            <div v-bind:class="{'input-group': serviceList.type == 1 || serviceList.type == 4}">
                <input type="number" class="form-control form-control-sm" :name="'serviceLists[lines][' + index + '][quantity]'" v-model="serviceList.quantity" @blur="compute" required step="0.001" :readonly="isForfait">
                <div class="input-group-append" v-if="serviceList.type == 1 || serviceList.type == 4">
                    <span class="input-group-text" id="inputGroup-sizing-sm">h</span>
                </div>
            </div>
            <input type="text" class="form-control form-control-sm mt-2" placeholder="unité" :name="'serviceLists[lines][' + index + '][unit]'" v-model="serviceList.unit" v-show="is_expanded === true"  v-if="serviceList.type != 1 && serviceList.type != 4">
            <div class="form-check mt-2" v-if="serviceList.type != 1 && serviceList.type != 4">
                <input type="checkbox" class="form-check-input" :id="'forfait' + serviceList.uniq" v-model="isForfait" @change="compute(null)">
                <label class="form-check-label" :for="'forfait' + serviceList.uniq">Forfait</label>
            </div>
        </td>
       
         <td>
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'serviceLists[lines][' + index + '][amount]'" v-model="serviceList.amount" @blur="compute(null)" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                        € <span v-if="serviceList.type == 1 || serviceList.type == 4">&nbsp;/ h</span>
                    </span>
                </div>
            </div>
        </td>
        <td >
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-center" :name="'serviceLists[lines][' + index + '][margin]'" v-model="serviceList.margin" @blur="compute('margin')" required min="0" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>
        </td>
         <td>
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'serviceLists[lines][' + index + '][selling]'" v-model="serviceList.selling" required step="0.001" @blur="compute('selling')">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                        € <span v-if="serviceList.type == 1 || serviceList.type == 4">&nbsp;/ h</span>
                    </span>
                </div>
            </div>
        </td>
        <td class="text-right">{{ currency(serviceList.total_selling) }}</td>
        <td class="text-right">
            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>


            <span class="btn btn-sm transparent" @click="emitEventServiceListDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
</tr>
</template>

<script>

import $ from 'jquery'
import Swal from "sweetalert2";

export default {
    name: 'service-list-form',
    props: ['serviceList', 'types', 'suggestionsRoute', 'purchaseTypes' ,'index', 'marginType'],
    data() {
        return {
             is_expanded: false,
        }
    },
    computed: {
        isForfait: {
            get() {
                return this.serviceList.unit === 'forfait';
            },
            set(value) {
                this.serviceList.unit = value ? 'forfait' : '';
            }
        }
    },
    methods: {
        expandRow: function(){
            this.is_expanded = !this.is_expanded;
        },
        emitEventServiceListDeleted: function(){
             Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('service-list-deleted', {
                            'index' : this.index,
                        })
                    }
                })
        },
        computeSelling: function(){
            if (this.marginType == 2) {
                return this.roundCurrency((parseFloat(this.serviceList.amount)/(100 - parseFloat(this.serviceList.margin))) * 100, 2)
            } else {
                var marginTotal = (parseFloat(this.serviceList.amount) / 100) * parseFloat(this.serviceList.margin)
                return this.roundCurrency((parseFloat(this.serviceList.amount) + marginTotal), 2)
            }
        },
        computeMargin: function(){
            var marginDiff = parseFloat(this.serviceList.selling) - parseFloat(this.serviceList.amount)

            if (this.marginType == 2) {
                if (parseFloat(this.serviceList.selling) != 0) {
                    var divider = parseFloat(this.serviceList.selling);
                } else {
                    return 0;
                }
            } else {
                if (parseFloat(this.serviceList.amount) != 0) {
                    var divider = parseFloat(this.serviceList.amount);
                } else {
                    return 0;
                }
            }

            return this.roundCurrency((marginDiff/divider) * 100, 2)
        },
        compute: function(from) {
            // Prévention champs vide
            if (this.serviceList.quantity == '' || this.serviceList.quantity == null) { this.serviceList.quantity = 0 }
            if (this.serviceList.amount == '' || this.serviceList.amount == null) { this.serviceList.amount = 0 }
            if (this.serviceList.total == '' || this.serviceList.total == null) { this.serviceList.total = 0 }
            if (this.serviceList.margin == '' || this.serviceList.margin == null) { this.serviceList.margin = 0 }
            if (this.serviceList.selling == '' || this.serviceList.selling == null) { this.serviceList.selling = 0 }
            if (this.serviceList.article_id == '' || this.serviceList.article_id == null) { this.serviceList.article_id = null }

            if (this.isForfait) { this.serviceList.quantity = 1 }

            if (from == null || from == 'margin') {
                this.serviceList.selling = this.computeSelling()
            } else if (from == 'selling') {
                this.serviceList.margin = this.computeMargin()
            }

            if (this.isForfait) {
                this.serviceList.total = parseFloat(this.serviceList.amount)
                this.serviceList.total_selling = parseFloat(this.serviceList.selling)
            } else {
                this.serviceList.total = parseFloat(this.serviceList.quantity) * parseFloat(this.serviceList.amount)
                this.serviceList.total_selling = parseFloat(this.serviceList.quantity) * parseFloat(this.serviceList.selling)
            }
        }
    },
    mounted(){
            var vm = this

         // Creation autocomplete
            $("#suggestionAutocomplete" + this.serviceList.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term }},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_amount: this.currency(item.amount)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        return $('<li>')
                            .append(vm.studySuggestionItemHtml(item))
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){ 
                        this.serviceList.article_id = null
                    }
                },
                select: (e, item) => {
                    this.serviceList.reference = item.item.reference
                    this.serviceList.designation = item.item.designation
                    this.serviceList.unit = item.item.unit
                    this.serviceList.amount = item.item.amount
                    this.serviceList.selling = item.item.selling
                    this.serviceList.description = item.item.description
                    this.serviceList.article_id = item.item.article_id ? item.item.article_id : null;
                    

                    this.compute('selling');
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.serviceList.uniq).autocomplete("search", '');
            });
    }
}
</script>